module.exports = __webpack_public_path__ + "media/img/agents-cards-01-01-769d4bf4c49c75f0a087376d107f21c1.jpg";